import resourceNames from "./resourceNames";
import apiRouteNames from "./apiRouteNames";

export default {
  // HoS
  [resourceNames.HOS_DRIVERS]: apiRouteNames.HOS_DRIVERS,
  [resourceNames.HOS_LOGS]: apiRouteNames.HOS_LOGS,
  [resourceNames.HOS_EVENTS]: apiRouteNames.HOS_EVENTS,
  [resourceNames.HOS_EVENTS_MASTER]: apiRouteNames.HOS_EVENTS_MASTER,
  [resourceNames.HOS_EVENTS_VIEW]: apiRouteNames.HOS_EVENTS_VIEW,
  [resourceNames.HOS_DRIVER_LOGS]: apiRouteNames.HOS_DRIVER_LOGS,
  [resourceNames.HOS_VIOLATIONS]: apiRouteNames.HOS_VIOLATIONS,
  [resourceNames.HOS_DRIVER_VIOLATIONS]: apiRouteNames.HOS_DRIVER_VIOLATIONS,
  [resourceNames.HOS_RECENT_VIOLATIONS]: apiRouteNames.HOS_RECENT_VIOLATIONS,
  [resourceNames.HOS_DRIVER_VIOLATION_DOCUMENTS]:
    apiRouteNames.HOS_DRIVER_VIOLATION_DOCUMENTS,
  [resourceNames.HOS_UNIDENTIFIED_DRIVING]:
    apiRouteNames.HOS_UNIDENTIFIED_DRIVING,
  [resourceNames.HOS_ELD_DISCONNECTIONS]: apiRouteNames.HOS_ELD_DISCONNECTIONS,
  [resourceNames.HOS_DISCONNECTED_DRIVINGS]:
    apiRouteNames.HOS_DISCONNECTED_DRIVINGS,
  [resourceNames.HOS_ELD_MALFUNCTIONS]: apiRouteNames.HOS_ELD_MALFUNCTIONS,
  [resourceNames.HOS_FMCSA_DATA_TRANSFER]:
    apiRouteNames.HOS_FMCSA_DATA_TRANSFER,

  // Safety
  [resourceNames.SAFETY_ALERTS]: apiRouteNames.SAFETY_ALERTS,

  // Locations
  [resourceNames.LOCATIONS_LIVETRACK_TOKENS]:
    apiRouteNames.LOCATIONS_LIVETRACK_TOKENS,
  [resourceNames.LOCATIONS_HISTORY_VEHICLES]:
    apiRouteNames.LOCATIONS_HISTORY_VEHICLES,
  [resourceNames.LOCATIONS_STATE_TRIPS]: apiRouteNames.LOCATIONS_STATE_TRIPS,
  [resourceNames.LOCATIONS_STATE_TRIPS_BY_STATE]:
    apiRouteNames.LOCATIONS_STATE_TRIPS_BY_STATE,
  [resourceNames.LOCATIONS_STATE_TRIPS_BY_VEHICLE]:
    apiRouteNames.LOCATIONS_STATE_TRIPS_BY_VEHICLE,

  // Assets
  [resourceNames.ASSETS_DVIR_HISTORY]: apiRouteNames.ASSETS_DVIR_HISTORY,
  [resourceNames.ASSETS_DVIR_VEHICLE_HISTORY]:
    apiRouteNames.ASSETS_DVIR_VEHICLE_HISTORY,
  [resourceNames.ASSETS_DVIR_VEHICLE_DEFECTS]:
    apiRouteNames.ASSETS_DVIR_VEHICLE_DEFECTS,
  [resourceNames.ASSETS_MAINTENANCE]: apiRouteNames.ASSETS_MAINTENANCE,
  [resourceNames.ASSETS_VEHICLE_MAINTENANCE]:
    apiRouteNames.ASSETS_VEHICLE_MAINTENANCE,
  [resourceNames.ASSETS_MALFUNCTIONS_DIAG]:
    apiRouteNames.ASSETS_MALFUNCTIONS_DIAG,

  // Administration
  [resourceNames.ADMIN_COMPANIES]: apiRouteNames.ADMIN_COMPANIES,
  [resourceNames.ADMIN_VEHICLES]: apiRouteNames.ADMIN_VEHICLES,
  [resourceNames.ADMIN_VEHICLES_VIEW]: apiRouteNames.ADMIN_VEHICLES_VIEW,
  [resourceNames.ADMIN_DRIVERS]: apiRouteNames.ADMIN_DRIVERS,
  [resourceNames.ADMIN_DRIVERS_VIEW]: apiRouteNames.ADMIN_DRIVERS_VIEW,
  [resourceNames.ADMIN_FLEET_MANAGERS]: apiRouteNames.ADMIN_FLEET_MANAGERS,
  [resourceNames.ADMIN_TRAILERS]: apiRouteNames.ADMIN_TRAILERS,
  [resourceNames.ADMIN_TRAILER_GPS_PROVIDERS]:
    apiRouteNames.ADMIN_TRAILER_GPS_PROVIDERS,
  [resourceNames.ADMIN_FUEL_PROVIDERS]: apiRouteNames.ADMIN_FUEL_PROVIDERS,
  [resourceNames.ADMIN_GROUPS]: apiRouteNames.ADMIN_GROUPS,
  [resourceNames.ADMIN_ROLES]: apiRouteNames.ADMIN_ROLES,
  [resourceNames.ADMIN_ELDS]: apiRouteNames.ADMIN_ELDS,
  [resourceNames.ADMIN_NOTIFICATIONS]: apiRouteNames.ADMIN_NOTIFICATIONS,
  [resourceNames.ADMIN_DVIR_FORMS]: apiRouteNames.ADMIN_DVIR_FORMS,
  [resourceNames.ADMIN_API_CLIENTS]: apiRouteNames.ADMIN_API_CLIENTS,
  [resourceNames.ADMIN_FLOW_API_CLIENTS]:
    apiRouteNames.ADMIN_FLOW_API_CLIENTS,
  [resourceNames.ADMIN_MOBILE_APP_VERSIONS]:
    apiRouteNames.ADMIN_MOBILE_APP_VERSIONS,

  // Master
  [resourceNames.MASTER_TENANTS]: apiRouteNames.MASTER_TENANTS,
  [resourceNames.MASTER_TENANTS_VIEW]: apiRouteNames.MASTER_TENANTS_VIEW,
  [resourceNames.MASTER_ELDS]: apiRouteNames.MASTER_ELDS,
  [resourceNames.MASTER_TENANT_ELDS_USAGE]:
    apiRouteNames.MASTER_TENANT_ELDS_USAGE,
  [resourceNames.MASTER_TENANT_ELDS]: apiRouteNames.MASTER_TENANT_ELDS,
  [resourceNames.MASTER_TENANT_OWN_ELDS]: apiRouteNames.MASTER_TENANT_OWN_ELDS,
  [resourceNames.MASTER_TENANT_REGISTRATIONS]:
    apiRouteNames.MASTER_TENANT_REGISTRATIONS,
  [resourceNames.MASTER_FLEET_MANAGERS]: apiRouteNames.MASTER_FLEET_MANAGERS,
  [resourceNames.MASTER_DEMO_ACCOUNTS]: apiRouteNames.MASTER_DEMO_ACCOUNTS,
  [resourceNames.ADMIN_ELD_MESSAGES]: apiRouteNames.ADMIN_ELD_MESSAGES,
  [resourceNames.MASTER_VIRTUAL_TENANTS]: apiRouteNames.MASTER_VIRTUAL_TENANTS,
  [resourceNames.ADMIN_ELD_EXPORT]: apiRouteNames.ADMIN_ELD_EXPORT,
  [resourceNames.ADMIN_ELD_IMPORT]: apiRouteNames.ADMIN_ELD_IMPORT,
  [resourceNames.MASTER_ELD_USAGE_REPORT_ARCHIVE]:
    apiRouteNames.MASTER_ELD_USAGE_REPORT_ARCHIVE,
  [resourceNames.REPORTS_ARCHIVE]: apiRouteNames.REPORTS_ARCHIVE,
  [resourceNames.PUBLIC_API_REDIRECTION]: apiRouteNames.PUBLIC_API_REDIRECTION,
  [resourceNames.PUBLIC_API_REDIRECTION_REQUESTS]:
    apiRouteNames.PUBLIC_API_REDIRECTION_REQUESTS,
};
